import React from 'react';
import { HomePage } from './pages/home';
import { LoginPage } from './pages/login';

export interface IRoute {
  path: string;
  name: string;
  component: React.FC;
  authGuard: boolean;
  noAuthGuard: boolean;
}

export const paths = {
  home: '/',
  login: '/login',
};

export const pageRoutes: IRoute[] = [
  {
    path: paths.home,
    name: "Home Page",
    component: HomePage,
    authGuard: true,
    noAuthGuard: false,
  },
  {
    path: paths.login,
    name: 'Login Page',
    component: LoginPage,
    authGuard: false,
    noAuthGuard: false
  }
];

export default pageRoutes;